const TYPE_TO_KIND = {
  'dmn:Decision': 'decision',
  'dmn:BusinessKnowledgeModel': 'businessKnowledgeModel',
  'dmn:KnowledgeSource': 'knowledgeSource',
  'dmn:InputData': 'inputData',
  'dmn:DecisionService': 'decisionService',
};

const REQUIREMENT_KINDS = {
  'dmn:InformationRequirement': 'information',
  'dmn:KnowledgeRequirement': 'knowledge',
  'dmn:AuthorityRequirement': 'authority',
};

function mapDrgElement(el) {
  const kind = TYPE_TO_KIND[el.$type];
  if (!kind) return null;

  const base = {
    id: el.id,
    name: el.name,
    kind,
    type: el.$type,
    raw: el,
    requirements: [],
  };

  const reqContainers = ['informationRequirement', 'knowledgeRequirement', 'authorityRequirement'];
  reqContainers.forEach((prop) => {
    const list = el.get ? el.get(prop) : el[prop];
    if (!list) return;
    list.forEach((req) => {
      const reqKind = REQUIREMENT_KINDS[req.$type];
      if (!reqKind) return;
      const sourceRef =
        (req.requiredDecision && req.requiredDecision.href) ||
        (req.requiredInput && req.requiredInput.href) ||
        (req.requiredKnowledge && req.requiredKnowledge.href) ||
        (req.requiredAuthority && req.requiredAuthority.href) ||
        null;
      base.requirements.push({
        id: req.id,
        kind: reqKind,
        sourceRef: sourceRef ? stripHrefHash(sourceRef) : null,
        targetRef: el.id,
        raw: req,
      });
    });
  });

  if (kind === 'decision' && el.decisionLogic) {
    base.decisionLogic = {
      type: el.decisionLogic.$type,
      raw: el.decisionLogic,
    };
  }
  if (kind === 'businessKnowledgeModel' && el.encapsulatedLogic) {
    base.encapsulatedLogic = {
      type: el.encapsulatedLogic.$type,
      raw: el.encapsulatedLogic,
    };
  }

  return base;
}

function stripHrefHash(href) {
  if (!href) return href;
  const idx = href.indexOf('#');
  return idx >= 0 ? href.slice(idx + 1) : href;
}

function mapDiagram(definitions) {
  const dmnDI = definitions.dmnDI;
  if (!dmnDI) return null;
  const diagrams = dmnDI.diagrams || [];
  if (!diagrams.length) return null;
  const first = diagrams[0];
  const shapes = [];
  const edges = [];
  const elements = first.diagramElements || first.DMNDiagramElement || [];
  elements.forEach((el) => {
    if (el.$type === 'dmndi:DMNShape') {
      const b = el.bounds || {};
      shapes.push({
        id: el.id,
        dmnElementRef: el.dmnElementRef && (el.dmnElementRef.id || stripHrefHash(el.dmnElementRef.href || '')),
        bounds: { x: b.x || 0, y: b.y || 0, width: b.width || 0, height: b.height || 0 },
        raw: el,
      });
    } else if (el.$type === 'dmndi:DMNEdge') {
      edges.push({
        id: el.id,
        dmnElementRef: el.dmnElementRef && (el.dmnElementRef.id || stripHrefHash(el.dmnElementRef.href || '')),
        waypoints: (el.waypoint || []).map((w) => ({ x: w.x, y: w.y })),
        raw: el,
      });
    }
  });
  return { id: first.id, name: first.name, shapes, edges, raw: first };
}

export function buildModel(definitions) {
  const drgElements = (definitions.drgElement || [])
    .map(mapDrgElement)
    .filter(Boolean);

  const itemDefinitions = (definitions.itemDefinition || []).map((it) => ({
    id: it.id,
    name: it.name,
    typeRef: it.typeRef,
    raw: it,
  }));

  const artifacts = (definitions.artifact || []).map((a) => ({
    id: a.id,
    type: a.$type,
    raw: a,
  }));

  return {
    id: definitions.id,
    name: definitions.name,
    namespace: definitions.namespace,
    exporter: definitions.exporter,
    exporterVersion: definitions.exporterVersion,
    drgElements,
    itemDefinitions,
    artifacts,
    diagram: mapDiagram(definitions),
  };
}

export { TYPE_TO_KIND, REQUIREMENT_KINDS };
